<template>
  <div class="diy-avatar">
    <figure class="diy-avatar__wrapper" :class="size">
      <img :src="src" :alt="alt" class="diy-avatar__image" />
    </figure>
  </div>
</template>

<script>
export default {
  name: 'AppAvatar',

  props: {
    src: {
      type: String,
      require: true,
    },

    alt: {
      type: String,
      default: '',
    },

    size: {
      type: String,
      default: 'small',
    },
  },
}
</script>

<style scoped>
.diy-avatar__wrapper {
  border-radius: 100%;
  overflow: hidden;
}

.diy-avatar__wrapper.small {
  width: 30px;
  height: 30px;
}

.diy-avatar__wrapper.medium {
  width: 60px;
  height: 60px;
}

.diy-avatar__wrapper.large {
  width: 120px;
  height: 120px;
}

.diy-avatar__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: top;
  box-shadow: 0 0 0px 2px #fff;
  backface-visibility: hidden;
}
</style>
